import { Reducer } from "redux";

import { DocumentUploadResponse } from "../models/api/Referral";
import { DocumentUploadDispatchTypes } from "../models/dispatchTypes/Referral";
import { ReferralDocumentFileDispatchTypes } from "../constants/Referral";

const initialState: DocumentUploadResponse = {
  loading: false,
  response: {
    dateCompleted: "",
    memberName: null,
    referralId: 0,
    requestId: "",
    responseMessage: "",
    serviceRequestId: 0,
    status: "",
    userNameCreated: null,
    documentUploads: []
  },
  error: null,
};

const DocumentUploadReducer: Reducer<
  DocumentUploadResponse,
  DocumentUploadDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case ReferralDocumentFileDispatchTypes.REFERRAL_DOCUMENT_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ReferralDocumentFileDispatchTypes.REFERRAL_DOCUMENT_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case ReferralDocumentFileDispatchTypes.REFERRAL_DOCUMENT_ERRORS: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case ReferralDocumentFileDispatchTypes.REFERRAL_DOCUMENT_RESET: {
      return initialState;
    }
  }
  return state;
};

export default DocumentUploadReducer;
